import React, { Component } from 'react';
import { connect } from "react-redux";
import ReactBootstrapSlider from 'react-bootstrap-slider';

const NAMES = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', "J", "K", "L", "M", "N"];

class SubSequenceMixComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    onChangeVolume(volume) {
        this.props.subSequence.fade = volume;
        if (this.props.currentSubSequence !== this.props.subSequence.id) {
            this.props.sequencerEngine.switchToSubSequence(
                this.props.subSequence.id);
        }
    }

    onClickMute() {
        this.props.subSequence.mute = !this.props.muted;
    }

    get patterns() {
        let track = this.props.subSequence.tracks[0];
        return track === undefined ? [] :
            track.patterns;
    }

    render() {
        let className = 'sub-sequence-fader';
        if (this.props.currentSubSequence === this.props.subSequence.id) {
            className += ' selected';
        }
        
        return (
            <div
              key={'sub-sequence-fader-' + this.props.subSequence.id}
              className={className}>
              <div className="mix-patterns">
                {this.patterns.map(
                    (pattern, i) =>
                        <Pattern
                          key={"pattern-" + i}
                          subSequence={this.props.subSequence}
                          sequencerEngine={this.props.sequencerEngine}
                          isCurrent={i === this.props.currentPattern}
                          pattern={i} />)}
              </div>
                <div className="sub-sequence-fader-and-info">
                <div className="sub-sequence-fader-empty"></div>
              <div className="volume-slider-container">
                <ReactBootstrapSlider
                  handle="square"
                  value={this.props.volume}
                  change={(e) => this.onChangeVolume(e.target.value)}
                  step={0.01}
                  max={1}
                  min={0}
                  orientation="vertical"
                  reversed={true}
                  /> 
              </div>
                <div
            onClick={() => this.onClickMute()}
            className={this.props.muted ? "sub-sequence-info muted" : "sub-sequence-info"}>
                {NAMES[this.props.i]}
              </div>
                </div>
            </div>
        );
    }
}

class Pattern extends Component {
    render() {
        let className = 'sub-sequence-pattern';
        if (this.props.isCurrent) {
            className += ' current';
        }
        return (
            <div
              onClick={() => this.switchToPattern()}
              className={className}>
              {this.props.pattern + 1} 
            </div>
        );
    }

    switchToPattern() {
        this.props.sequencerEngine.switchToPattern(
            this.props.pattern, false, this.props.subSequence);
        this.props.sequencerEngine.switchToSubSequence(
            this.props.subSequence.id);
    }
}

const mapStateToProps = (state, props) => {
    let volume = state.mix.subSequenceFades[props.subSequence.id];
    let engineId = props.sequencerEngine.engineId;
    return {
        volume: volume === undefined ? 1 : volume,
        muted: state.mix.subSequenceMuted[props.subSequence.id],
        currentPattern: state.sequencer.currentPattern[props.subSequence.id] || 0,
        currentSubSequence: state.sequencer.currentSubSequence[engineId],
    };
};

export default connect(mapStateToProps, null)(SubSequenceMixComponent);
